export enum EWeekDay {
    Sunday,
    Monday,
    Tuesday,
    Wednesday,
    Thursday,
    Friday,
    Saturday,
}

export interface IWorkScheduleDay {
    id?: number;
    workScheduleId?: number;
    weekday: EWeekDay;
    startTime?: string | null;
    endTime?: string | null;
    breakMinutes?: number | null;
    isHoliday: boolean;
}

export interface IWorkSchedule {
    id?: number;
    userId: number;
    propertyGroupId: number;
    days: IWorkScheduleDay[];
}
